import { FormatTime } from 'features/autocheck/utils'
import { EOBDownload, ViewEOB } from './ViewEOB'

export const EOBColumnConfig = [
  {
    field: 'fileName',
    headerName: 'File Name',
    width: 350,
  },
  {
    field: 'created',
    headerName: 'EOB Received',
    width: 200,
    valueFormatter: (params: { value: string | number | Date }) => {
      return FormatTime(params.value)
    },
    sort: 'desc',
  },
  {
    id: 'view',
    headerName: 'View',
    cellRenderer: ViewEOB,
    width: 100,
    pinned: 'right',
  },
  {
    id: 'download',
    headerName: 'Download',
    cellRenderer: EOBDownload,
    width: 150,
    pinned: 'right',
  },
]
